import { CarRepository } from '../repositories'

export interface CarBrandsBo extends CarRepository.CarBrandsRespDto {}

/** 取得品牌清單 */
export async function getCarBrands(): Promise<CarBrandsBo> {
  const carBrandsDto = await CarRepository.getCarBrands()

  return carBrandsDto
}

export interface GetCarModelsByCarBrandParams extends CarRepository.GetCarModelsByCarBrandReqDto {}

export interface CarModelsBo extends CarRepository.CarModelsRespDto {}

/** 依品牌取得車種清單 */
export async function getCarModelsByCarBrand(params: GetCarModelsByCarBrandParams): Promise<CarModelsBo> {
  const carModelsDto = await CarRepository.getCarModelsByCarBrand(params)

  return carModelsDto
}

export interface GetSfxsParams extends CarRepository.GetSfxsReqDto {}

export interface SfxsBo extends CarRepository.SfxsRespDto {}

/** 依車種取得SFX清單 */
export async function getSfxs(params: GetSfxsParams): Promise<SfxsBo> {
  const sfxsDto = await CarRepository.getSfxs(params)

  return sfxsDto
}

export interface CarPartsBo extends CarRepository.CarPartsRespDto {}

/** 取得組裝區域 */
export async function getCarParts(): Promise<CarPartsBo> {
  const carPartsDto = await CarRepository.getCarParts()

  return carPartsDto
}

export interface PioItemsBo extends CarRepository.PioItemsRespDto {}

/** 取得PIO清單 */
export async function getPioItems(): Promise<PioItemsBo> {
  const pioItemsDto = await CarRepository.getPioItems()

  return pioItemsDto
}

export interface CarModelsBo extends CarRepository.CarModelsRespDto {}

/** 取得車種 */
export async function getCarModels(): Promise<CarModelsBo> {
  const carModelsDto = await CarRepository.getCarModels()

  return carModelsDto
}
